import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MP',
  name: 'María P.',
  role: 'Docente técnica de alimentos — Medellín, Colombia',
  text: '"Mis alumnos por fin entienden la diferencia entre una conserva segura y una peligrosa. Antes yo misma perdía horas buscando cómo explicar el pH y los grados Brix de forma clara. Ahora entro al taller con todo listo."'
}, {
  initials: 'JR',
  name: 'Jorge R.',
  role: 'Profesor de tecnología de alimentos — Buenos Aires, Argentina',
  text: '"Nunca más llegué a una práctica sin saber cómo explicar el proceso de curado o la diferencia entre un embutido fresco y uno madurado. El material hace el trabajo pesado por mí."'
}, {
  initials: 'SL',
  name: 'Sofía L.',
  role: 'Docente de educación técnica agropecuaria — Bogotá, Colombia',
  text: '"Las fichas técnicas con formulaciones exactas me ahorran horas cada semana. No improviso nunca más frente a mis alumnos en el taller."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-dark-card border-y border-dark-border" data-id="element-267">
      <div className="max-w-7xl mx-auto px-4" data-id="element-268">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-269">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-black border border-gold/20 p-6 rounded-2xl relative" data-id="element-270">
              <div className="flex gap-1 text-gold mb-4" data-id="element-271">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-272" />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-273">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-274">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-275">
                  {t.initials}
                </div>
                <div data-id="element-276">
                  <div className="font-bold text-white text-sm" data-id="element-277">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-278">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}